import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns isTablet boolean from page state
 * @return {boolean}
 */
export default function useIsTablet() {
    return useAppSelector((state) => state?.page.isTablet)
}